import React, { useState, useEffect, useMemo } from "react";
import Tablestyles from "../ROCITable.module.css";
import TableContainer from "@material-ui/core/TableContainer";
import { config } from "../../../config/config";
import { exportToExcel } from "../../../utils/exportToExcel";
import { updateAlert, updateSourceInputs } from "../../../redux/actions";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  withStyles,
} from "@material-ui/core";
import classNames from "classnames";
import TablePagination from "@material-ui/core/TablePagination";
import SearchBar from "../../../components/Searchbar/searchbar";
import CustomModal from "../../../components/modal/modal";
import CustomSelect from "../../../components/input/select";
import RecommandationModal from "../../../components/modal/recommandModel";
import MultiFilter from "../../../components/Dialog/MultiFilter";
import Loader from "../../../components/Loader/Loader";
import ColumnFilter from "../../../components/Dialog/ColumnFilter";
import * as XLSX from "@lokalise/xlsx";
import { hasDangerousCode } from "../../../utils/utils";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#e5e5e5",
    color: "#212529",
    height: 3,
    width: "auto", // let content decide
    minWidth: "50px",
    maxWidth: "250px",
    whiteSpace: "normal",
  },
  body: {
    fontSize: 12,
    fontFamily: "Roboto,Helvetica,Arial,sans-serif",
    width: "auto", // let content decide
    minWidth: "50px",
    maxWidth: "250px",
  },
  root: {
    padding: "15px",
  },
}))(TableCell);

let api = config.api.api_url;

const Input = ({
  name,
  error,
  validation,
  childHasError,
  columnDataArr,
  value,
  classes,
  tableName,
  ...props
}) => {
  const [hasError, setError] = useState(false);
  const handleOnChange = (e) => {
    const hasError = validation(e, columnDataArr);
    if (!hasError) {
      childHasError(true);
      setError(true);
    } else {
      childHasError(false);
      setError(false);
    }
    props.onChange(e);
  };

  return (
    <>
      <div
        className={classNames(
          classes.inputWrapperDiv,
          `inputWrapperDiv${tableName}`,
        )}
      >
        <textarea
          className={classNames(classes.input, `input${tableName}`)}
          rows={2}
          style={{ width: "100%", marginBottom: "-20px" }}
          name={name}
          value={value || ""}
          onChange={handleOnChange}
        />
        <p className={classNames(classes.error, `error${tableName}`)}>
          {hasError && error}
        </p>
      </div>
    </>
  );
};

const EditableRow = ({
  keys,
  fieldsArr = [],
  editData = {},
  allRowsData,
  customStyles,
  tableName,
  updateSourceInputs,
  sourceData,
  brand_data,
  classes = {},
  editingIndex,
  isEditing,
  selectClasses,
  inputClasses,
  user,
  updateAlert,
  tableHeadColumns,
  ...props
}) => {
  let initializeObj = {};
  fieldsArr.forEach((item) => {
    initializeObj[item.name] = "";
  });
  const PRIMARY_COLUMN = sourceData?.data?.dropdown?.table_primary_key || "";
  const [rowHasError, setRowHasError] = useState(false);
  const [rowData, setRowData] = useState(editData ? editData : initializeObj);
  const [editedRowData, setEditedRowData] = useState({
    [PRIMARY_COLUMN]: rowData?.[PRIMARY_COLUMN],
  });
  const DROPDOWN_DATA = sourceData?.data?.dropdown || {};
  const Edit_Column_Module = DROPDOWN_DATA?.edit_model_column_list || [];

  const handleSave = () => {
    // CHECKS CHANGES MADE IN RECORD
    const is_Value_Changed = Edit_Column_Module.some((item) => {
      return rowData[item.name] !== editData[item.name];
    });

    const MODIFIED_MAPPED_DATA = sourceData.modified_mapped_data;
    const index = MODIFIED_MAPPED_DATA.findIndex(
      (item) => item?.[PRIMARY_COLUMN] === rowData?.[PRIMARY_COLUMN],
    );

    if (is_Value_Changed) {
      let updatedArray;
      if (index !== -1) {
        //updating the existing object by adding new key: value
        const { [PRIMARY_COLUMN]: extractedValue, ...editedItems } =
          editedRowData;
        updatedArray = MODIFIED_MAPPED_DATA.map((item, i) =>
          i === index
            ? {
                ...item,
                ...editedItems,
              }
            : item,
        );
      } else {
        //adding a new object to the array
        updatedArray = [...MODIFIED_MAPPED_DATA, editedRowData];
      }

      //Updating the redux store with final result
      updateSourceInputs("modified_mapped_data", updatedArray);
      props.handleSave(rowData);
    } else {
      updateAlert({
        open: true,
        message: "No Value has been changed",
        severity: "error",
        closeFlag: true,
      });
    }
  };

  const handleOnChange = (key, val) => {
    const updatedData = Object.assign({}, rowData, {
      [key]: val,
    });
    setEditedRowData((prev) => ({
      ...prev,
      [key]: val,
    }));
    setRowData(updatedData);
  };

  const handleOnInputChange = (e, itemName) => {
    const ColumnValue = e?.target?.value || "";
    const ALLOWED_SPECIAL_CHARACTERS =
      DROPDOWN_DATA?.allowed_special_characters || "";
    const hasExplicitDanger = hasDangerousCode(
      ColumnValue,
      ALLOWED_SPECIAL_CHARACTERS,
    );

    if (hasExplicitDanger && !hasExplicitDanger?.isValid) {
      updateAlert({
        open: true,
        message: `${hasExplicitDanger?.error}`,
        severity: "error",
        closeFlag: true,
      });
      return false;
    }

    const updatedData = Object.assign({}, rowData, {
      [itemName]: ColumnValue,
    });
    setEditedRowData((prev) => ({
      ...prev,
      [itemName]: ColumnValue,
    }));
    setRowData(updatedData);
  };

  const handleCancel = () => {
    props.handleCancel(editingIndex);
  };

  const handleValidate = () => {
    return true;
  };

  return (
    <TableRow
      key={`editable-${keys}`}
      className={classNames(classes.tableBodyRow, `tableBodyRow_${tableName}`)}
    >
      {fieldsArr.map((item, i) => {
        return item.name === PRIMARY_COLUMN ? (
          <StyledTableCell
            key={`key-${i}`}
            className={classNames(
              classes.tableBodyCell,
              `tableBodyCell_${tableName}`,
            )}
            style={{
              textWrap: "balance",
              width: "25%",
            }}
          >
            <div
              style={{ display: "flex", gap: "10px" }}
              key={`key_div_row${i}`}
            >
              <div>
                {rowData[item.name]?.length > 0 ? rowData[item.name] : ""}
              </div>
            </div>
          </StyledTableCell>
        ) : (
          <StyledTableCell
            className={classNames(
              classes.tableBodyCell,
              `tableBodyCell_${tableName}`,
            )}
            key={i}
          >
            {item.type === "select" ? (
              <>
                <CustomSelect
                  classes={{
                    ...selectClasses,
                  }}
                  tableName={tableName}
                  name={item.name}
                  onChange={handleOnChange}
                  options={DROPDOWN_DATA?.[item.name] || []}
                  customStyles={customStyles}
                  value={rowData?.[item.name] || ""}
                  error={""}
                  selectMessage={""}
                  validation={handleValidate}
                  readonly={false}
                  showLabel={false}
                />
              </>
            ) : item.type === "input" ? (
              typeof rowData?.[item.name] !== "string" ? (
                <Input
                  columnDataArr={(allRowsData || []).map(
                    (obj) => obj.rowData[item.name],
                  )}
                  tableName={tableName}
                  classes={{ ...inputClasses }}
                  type={item.type}
                  name={item.name}
                  onChange={(e) => handleOnInputChange(e, item.name)}
                  value={
                    rowData[item.name] == null
                      ? ""
                      : JSON.stringify(rowData[item.name]) || ""
                  }
                  item={item.name}
                  childHasError={(bool) => setRowHasError(bool)}
                  error={""}
                  validation={handleValidate}
                />
              ) : (
                <>
                  <Input
                    columnDataArr={(allRowsData || []).map(
                      (obj) => obj.rowData[item.name],
                    )}
                    tableName={tableName}
                    classes={{ ...inputClasses }}
                    type={item.type}
                    name={item.name}
                    onChange={(e) => handleOnInputChange(e, item.name)}
                    value={
                      typeof rowData[item.name] === "string"
                        ? rowData[item.name]
                        : ""
                    }
                    item={item.name}
                    childHasError={(bool) => setRowHasError(bool)}
                    error={""}
                    validation={handleValidate}
                  />
                </>
              )
            ) : (
              <>
                {rowData[item.label === "UPC" ? "UPC" : item.name] &&
                rowData[item.label === "UPC" ? "UPC" : item.name].length > 30
                  ? rowData[item.label === "UPC" ? "UPC" : item.name].slice(
                      0,
                      30,
                    ) + "..."
                  : rowData[item.label === "UPC" ? "UPC" : item.name]}
              </>
            )}
          </StyledTableCell>
        );
      })}

      {/* Action Buttons */}
      <StyledTableCell
        className={classNames(
          classes.tableBodyCell,
          `tableBodyCell_${tableName}`,
        )}
      >
        <i
          className="material-icons-outlined "
          style={{ color: "red" }}
          onClick={handleCancel}
        >
          cancel
        </i>
        <i
          className="material-icons-outlined "
          style={{ color: "green" }}
          onClick={handleSave}
        >
          done
        </i>
      </StyledTableCell>
    </TableRow>
  );
};

const Row = ({
  keys,
  rowData,
  headingRow,
  handleEditRow,
  handleModalOpen,
  handleRecommendationModalopen,
  classes,
  tableName,
  isAdding,
  isEditing,
  rowChecked,
  allRowsData,
  updateSourceHandler,
  sourceData,
}) => {
  // const [checkedRow,setCheckedRow] = useState(rowChecked);
  let data = rowData.rowData;

  const Is_Recommendation_Enabled = useMemo(() => {
    const Primary_Condition =
      sourceData?.data?.dropdown?.recommendation_details?.is_recommendation;
    if (
      Primary_Condition &&
      sourceData.get_recommendation_for_all_rows &&
      sourceData.get_recommendation_status === "Success"
    )
      return true;

    if (Primary_Condition && !sourceData.get_recommendation_for_all_rows)
      return true;

    return false;
  }, [
    sourceData.get_recommendation_for_all_rows,
    sourceData.get_recommendation_status,
  ]);

  const handleEditingRow = () => {
    handleEditRow(rowData.item_Id);
  };

  const handleEachCheckBox = (item_Id) => {
    const TABLE_DATA = allRowsData.map((data) => {
      if (data.item_Id === item_Id) {
        return {
          ...data,
          isCheckedRow: !data.isCheckedRow,
        };
      }
      return data;
    });
    const rowCheckedCount = TABLE_DATA.filter((item) => item.isCheckedRow);
    updateSourceHandler(TABLE_DATA, rowCheckedCount.length);
  };

  return (
    <TableRow
      key={`Rowkey-${keys}`}
      // className={classNames(classes.tableBodyRow, `tableBodyRow_${tableName}`)}
      className={"table-row"}
      style={{ cursor: "pointer" }}
    >
      {headingRow.map(({ label, name }, indexs) => (
        <>
          {indexs !== headingRow.length - 1 &&
            (name === (sourceData?.data?.dropdown?.table_primary_key || "") ? (
              <StyledTableCell
                key={`key-${indexs}`}
                className={classNames(
                  classes.tableBodyCell,
                  `tableBodyCell_${tableName}`,
                )}
                style={{
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                  }}
                  key={`key_div_row${indexs}`}
                >
                  {sourceData.data.dropdown.recommendation_details
                    ?.is_recommendation && (
                    <input
                      type="checkbox"
                      checked={rowChecked}
                      onChange={(e) => {
                        handleEachCheckBox(rowData.item_Id);
                      }}
                    />
                  )}
                  <div
                    onClick={(e) => handleModalOpen(e, data, true)}
                    className="scrollable-cell cell-wrapper"
                    style={{
                      position: "relative",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      height: "40px",
                      padding: "2px 3px",
                      border:
                        data[name]?.length > 100 ? "1px solid #e0e0e0" : "none",
                      overflowY: data[name]?.length > 40 ? "auto" : "visible",
                      whiteSpace: "nowrap",
                      // display: "block",
                      textWrap: "wrap",
                    }}
                  >
                    {data?.[name]?.length > 0 ? data[name] : "Null"}
                  </div>
                </div>
              </StyledTableCell>
            ) : typeof data?.[name] === "string" ? (
              <StyledTableCell
                key={`key-${indexs}`}
                className={classNames(
                  classes.tableBodyCell,
                  `tableBodyCell_${tableName}`,
                )}
                onClick={(e) => handleModalOpen(e, data, true)}
                style={{ cursor: "pointer" }}
              >
                {data[label === "UPC" ? "UPC" : name]?.length > 0
                  ? data[label === "UPC" ? "UPC" : name]?.length > 30
                    ? `${data[label === "UPC" ? "UPC" : name]}`
                    : data[label === "UPC" ? "UPC" : name]
                  : "Null"}
              </StyledTableCell>
            ) : typeof data?.[name] === "object" ? (
              <StyledTableCell
                key={`key-${indexs}`}
                className={classNames(
                  classes.tableBodyCell,
                  `tableBodyCell_${tableName}`,
                )}
                onClick={(e) => handleModalOpen(e, data, true)}
                style={{ cursor: "pointer" }}
              >
                {data[name] && Object.keys(data[name]).length > 0
                  ? JSON.stringify(data[name])
                  : "Null"}
              </StyledTableCell>
            ) : (
              <StyledTableCell
                key={`key-${indexs}`}
                className={classNames(
                  classes.tableBodyCell,
                  `tableBodyCell_${tableName}`,
                )}
                onClick={(e) => handleModalOpen(e, data, true)}
                style={{ cursor: "pointer" }}
              >
                {data[name] && data[name].toString()?.length > 0
                  ? data[name].toString()
                  : "Null"}
              </StyledTableCell>
            ))}
        </>
      ))}

      {/* Action Buttons */}
      <StyledTableCell
        className={classNames(
          classes.tableBodyCell,
          `tableBodyCell_${tableName}`,
        )}
      >
        <div className="action-icon-container">
          <span>
            {!isEditing ? (
              <i
                className="material-icons-outlined "
                disabled={isAdding || isEditing}
                style={{
                  cursor: isAdding || isEditing ? "not-allowed" : "pointer",
                }}
                onClick={handleEditingRow}
              >
                edit
              </i>
            ) : (
              <i
                className="material-icons-outlined "
                style={{ cursor: "not-allowed" }}
              >
                edit
              </i>
            )}
          </span>
          {Is_Recommendation_Enabled && (
            <span>
              {!isEditing ? (
                <i
                  className="material-icons-outlined "
                  disabled={isAdding || isEditing}
                  // disabled={true}
                  style={{
                    cursor: isAdding || isEditing ? "not-allowed" : "pointer",
                  }}
                  // style={{
                  //   cursor: "not-allowed",
                  // }}
                  onClick={(e) =>
                    handleRecommendationModalopen(e, rowData, true)
                  }
                >
                  assistant
                </i>
              ) : (
                <i
                  className="material-icons-outlined "
                  style={{ cursor: "not-allowed" }}
                >
                  assistant
                </i>
              )}
            </span>
          )}
        </div>
      </StyledTableCell>
    </TableRow>
  );
};

const EditableTableAttribute = (props) => {
  const { classes = {}, tableName, ...rest } = props;
  const [allRowsData, setAllRowsData] = useState(props.defaultData || []);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(props.page || 0);
  const [isAdding, setIsAdding] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [checkedRowCount, setCheckedRowCount] = useState(
    props.checkedRowCount || 0,
  );
  const [isAllRowsInPageChecked, setIsAllRowsInPageChecked] = useState(false);
  const [openModel, setOpenModel] = useState(false);
  const [modalData, setModalData] = useState({});
  const [isRecommand, setIsRecommand] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [paginatedRows, setPaginatedRows] = useState(
    allRowsData?.slice(0, rowsPerPage) || [],
  );
  const PRIMARY_COLUMN =
    props?.source_data?.data?.dropdown?.table_primary_key || "";

  //   Multi Filter States
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);
  const [appliedFilters, setAppliedFilters] = useState(
    props.source_data.appliedFilters || [],
  );
  const [filteredRows, setFilteredRows] = useState();
  const [tableHeadColumns, setTableHeadColumns] = useState([
    ...(
      props?.source_data?.data?.dropdown?.table_header_column_list ?? []
    ).filter(
      (item) =>
        !props?.source_data?.data?.dropdown?.unwanted_table_column.includes(
          item.name,
        ),
    ),
    { label: "Actions", name: "actions" },
  ]);
  const [selectedColumns, setSelectedColumns] = useState(
    props?.source_data?.data?.dropdown?.edit_model_column_list
      .filter((item) => {
        return tableHeadColumns.some((col) => {
          return item.name === "UPC"
            ? col.label === item.name
            : col.name === item.name;
        });
      })
      ?.sort(
        (a, b) =>
          tableHeadColumns.findIndex((col) => col.name === a.name) -
          tableHeadColumns.findIndex((col) => col.name === b.name),
      ) || [],
  );

  const customStyles = {
    menuPortal: (base) => ({
      ...base,
      maxHeight: "90%",
      fontSize: 12,
      fontFamily: "Hind Siliguri !important",
      zIndex: 9999,
    }),
  };

  const RECOMMENDATION_STATUS_COLOR = useMemo(() => {
    if (props.source_data.get_recommendation_status === "Success")
      return { bg_color: "rgba(0, 128, 0, 0.2)", icon: "green" };
    if (props.source_data.get_recommendation_status === "In Progress")
      return { bg_color: "rgba(255, 165, 0, 0.2)", icon: "orange" };
    if (props.source_data.get_recommendation_status === "Failed")
      return { bg_color: "rgba(255, 0, 0, 0.2)", icon: "red" };
    return { bg_color: "rgba(255, 0, 0, 0.2)", icon: "red" };
  }, [
    props.source_data.get_recommendation_for_all_rows,
    props.source_data.get_recommendation_status,
    props.source_data.get_recommendation_error_message,
  ]);

  const handlePaginatedRows = (newPage, AllRowsData) => {
    const start = newPage * rowsPerPage;
    const end = start + rowsPerPage;
    const currentPageRows = AllRowsData
      ? AllRowsData.slice(start, end)
      : allRowsData.slice(start, end);
    return currentPageRows;
  };

  const handleSave = (row) => {
    props.setGlobalEdit(true);
    props.setIsEdit(false);
    let arr;
    if (isEditing) {
      arr = props.source_data.current_mapped_data.map((item, i) => {
        return i === editingIndex
          ? { ...item, isEditing: false, rowData: row }
          : item;
      });
      setAllRowsData(arr);
      setEditingIndex(null);
      setIsEditing(false);
    } else {
      arr = [
        ...props.source_data.current_mapped_data,
        { isEditing: false, rowData: row },
      ];
      setAllRowsData(arr);
      setIsAdding(false);
    }
    props.updateSourceInputs("current_mapped_data", arr);
    props.updateSourceInputs("any_row_isEditing", false);
    const Paginated_Rows = handlePaginatedRows(page, arr);
    setPaginatedRows(Paginated_Rows);
    setAllRowsData(arr);
    setEditingIndex(null);
    setIsEditing(false);
    props.updateAlert({
      open: true,
      message: "Mapping changes saved successfully",
      severity: "info",
      closeFlag: true,
    });
  };

  const handleEditRow = (index) => {
    props.setIsEdit(true);
    const arr = props.source_data.current_mapped_data.map((item, i) =>
      item.item_Id === index ? { ...item, isEditing: true } : item,
    );
    const arr_Filtered_rows = props.source_data.filtered_Rows.map((item, i) =>
      item.item_Id === index ? { ...item, isEditing: true } : item,
    );

    props.updateSourceInputs("current_mapped_data", arr);
    props.updateSourceInputs("any_row_isEditing", true);
    props.updateSourceInputs("filtered_Rows", arr_Filtered_rows);
    setAllRowsData(arr);
    const Paginated_Rows = handlePaginatedRows(page, arr);
    setPaginatedRows(Paginated_Rows);
    setEditingIndex(index);
    setIsEditing(true);
  };

  const handleCancel = (index) => {
    props.setIsEdit(true);
    let arr;
    let arr_Filtered_rows;
    if (isEditing) {
      arr = props.source_data.current_mapped_data.map((item, i) =>
        i === index ? { ...item, isEditing: false } : item,
      );
      arr_Filtered_rows = props.source_data.filtered_Rows.map((item, i) =>
        item.item_Id === index ? { ...item, isEditing: false } : item,
      );
      setAllRowsData(arr);
      setEditingIndex(null);
      setIsEditing(false);
    } else {
      setIsAdding(false);
    }

    props.updateSourceInputs("current_mapped_data", arr);
    props.updateSourceInputs("any_row_isEditing", false);
    props.updateSourceInputs("filtered_Rows", arr_Filtered_rows);
    const Paginated_Rows = handlePaginatedRows(page, arr);
    setPaginatedRows(Paginated_Rows);
    setAllRowsData(arr);
    setEditingIndex(null);
    setIsEditing(false);
  };

  const handleDeleteRow = (index) => {
    const arr = allRowsData.filter((_, i) => i !== index);
    setAllRowsData(arr);
    props.getData(arr.map(({ rowData }) => rowData));
    props.updateSourceInputs("any_row_isEditing", false);
  };

  const handleSearchValue = (val) => {
    setPage(0);
    setRowsPerPage(10);
    if (!val || val.length === 0) {
      setAllRowsData(props.source_data.current_mapped_data);
      setSearchValue("");
      props.updateSourceInputs("searchValue", "");
      if (
        props.source_data.appliedFilters &&
        props.source_data.appliedFilters.length > 0
      ) {
        handleApplyFilter(
          appliedFilters.Column,
          appliedFilters.Values,
          0,
          props.source_data.appliedFilters,
        );
      } else {
        const Paginated_Rows = handlePaginatedRows(
          0,
          props.source_data.current_mapped_data,
        );
        setPaginatedRows(Paginated_Rows);
      }
    } else {
      let filtered;
      if (
        props.source_data.filtered_Rows &&
        props.source_data.filtered_Rows.length > 0
      ) {
        filtered = props.source_data.filtered_Rows.filter((item) => {
          return props.source_data.data.dropdown.search_filter_details.search_filter_attributes.some(
            (attribute) => {
              return (item?.rowData[attribute.name] || "")
                .toLowerCase()
                .includes(val.toLowerCase());
            },
          );
        });
      } else {
        filtered = props.source_data.current_mapped_data.filter((item) => {
          return props.source_data.data.dropdown.search_filter_details.search_filter_attributes.some(
            (attribute) => {
              return (item?.rowData[attribute.name] || "")
                .toLowerCase()
                .includes(val.toLowerCase());
            },
          );
        });
      }
      setSearchValue(val);
      props.updateSourceInputs("searchValue", val);
      setAllRowsData(filtered);
      const Paginated_Rows = handlePaginatedRows(0, filtered);
      setPaginatedRows(Paginated_Rows);
    }
  };

  const handleCheckboxAll = () => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    const updated = allRowsData.map((item, i) => {
      if (i >= startIndex && i < endIndex) {
        return {
          ...item,
          isCheckedRow: !isAllRowsInPageChecked,
        };
      }
      return item;
    });

    const count = updated.filter((item) => item.isCheckedRow).length;

    setAllRowsData(updated);
    setCheckedRowCount(count);
    setIsAllRowsInPageChecked(!isAllRowsInPageChecked);
    props.updateSourceHandler(updated, count);
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
    const Paginated_Rows = handlePaginatedRows(newPage);
    setPaginatedRows(Paginated_Rows);

    const startIndex = newPage * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    const AllRowsChecked = allRowsData
      .slice(startIndex, endIndex)
      .every((item, i) => {
        return item.isCheckedRow === true;
      });

    setIsAllRowsInPageChecked(AllRowsChecked);
  };

  const handleChangeRowsPerPage = (e) => {
    const value = parseInt(e.target.value);
    setRowsPerPage(value);
    const start = 0 * value;
    const end = start + value;
    const currentPageRows = allRowsData.slice(start, end);
    setPaginatedRows(currentPageRows);
    setPage(0);
  };

  const handleModalopen = async (e, data, open) => {
    e.preventDefault();
    e.stopPropagation();

    setModalData(data);
    setOpenModel(open);
  };

  const handleCloseModel = () => {
    setModalData({});
    setOpenModel(false);
  };

  const handleRecommendationModalopen = async (e, data, open) => {
    e.preventDefault();
    e.stopPropagation();

    setModalData(data);
    setOpenModel(open);
    setIsRecommand(true);
  };

  const handleRecommendationCloseModal = () => {
    setModalData({});
    setOpenModel(false);
    setIsRecommand(false);
  };

  const handleOpenColumnFilter = (e) => {
    if (isEditing) {
      props.updateAlert({
        open: true,
        message:
          "Cannot Filter columns while editing. Please try after editing the record.",
        severity: "info",
        closeFlag: true,
      });
      return;
    }
    setAnchorE2(e.currentTarget);
  };

  const handleDownload = () => {
    if (isEditing) {
      props.updateAlert({
        open: true,
        message:
          "Cannot download while editing. Please try after editing the record.",
        severity: "info",
        closeFlag: true,
      });
      return;
    }

    // INITIALIZING TABLE DATA
    const MetaData_Filter =
      props?.source_data?.data?.dropdown?.metadata_filter || [];
    const IS_SPREADABLE_DATA =
      props.source_data.data.dropdown.conversion_column_details.is_spread;
    const Convertion_Column_Details =
      props.source_data.data.dropdown.conversion_column_details
        .conversion_columns;
    const COUNTRY = props?.source_data.current_mapped_country.find((item) => {
      return item.label === props?.source_data.current_country;
    });
    let Data =
      props?.source_data?.current_mapped_data?.map((item) => ({
        ...item.rowData,
        COUNTRY: COUNTRY?.value || "",
        SOURCE_FILE_ID: props?.source_data?.current_category || "",
        IS_AI_RECOMMENDED: item?.isAiEnriched || false,
      })) || [];

    if (!Data || !Data.length > 0) {
      props.updateAlert({
        open: true,
        message: "No sample data available to download.",
        severity: "Failed",
        closeFlag: true,
      });
      return;
    }

    if (IS_SPREADABLE_DATA) {
      Data =
        Data?.map((item) => ({
          ...item,
          COUNTRY: COUNTRY?.value || "",
          SOURCE_FILE_ID: props?.source_data?.current_category || "",
        })) || [];
    } else {
      Data =
        Data?.map((item) => ({
          ...item,
          COUNTRY: COUNTRY?.value || "",
          SOURCE_FILE_ID: props?.source_data?.current_category || "",
          IS_AI_RECOMMENDED: item?.isAiEnriched || false,
        })) || [];
    }

    let tableData = [];

    if (IS_SPREADABLE_DATA) {
      tableData =
        Data?.map((item) => {
          let Spreadable_Columns = [];
          let All_Grouped_Spreaded_columns = {};
          let Spreadable_Column_Removed = {};

          // GET THE MATCHING SPREADABLE COLUMN DETAILS
          Object.keys(item).forEach((col_name) => {
            const matched = Convertion_Column_Details.filter((con_column) =>
              con_column.child_columns_name?.some(
                (child_col) => child_col === col_name,
              ),
            );

            // accumulate all matches
            if (matched.length > 0) {
              Spreadable_Columns.push(...matched);
            }
          });

          // GROUP THE SPREDABLE COLUMNS TO ITS PARENT COLUMN
          if (Spreadable_Columns.length > 0) {
            Spreadable_Columns.forEach((spread_col) => {
              Object.keys(item).forEach((key) => {
                if (spread_col.child_columns_name.includes(key)) {
                  All_Grouped_Spreaded_columns = {
                    ...All_Grouped_Spreaded_columns,
                    [spread_col.parent_column_name]: {
                      ...All_Grouped_Spreaded_columns?.[
                        spread_col.parent_column_name
                      ],
                      [key]: item?.[key],
                    },
                  };
                }
              });
            });
          } else {
            All_Grouped_Spreaded_columns = {};
          }

          // REMOVE'S THE SPREADED COLUMN FROM THE ROW DATA
          Object.keys(item).forEach((col_name) => {
            const isSpreadableColumn = Spreadable_Columns.some((spread_col) =>
              spread_col.child_columns_name.includes(col_name),
            );

            if (!isSpreadableColumn) {
              Spreadable_Column_Removed = {
                ...Spreadable_Column_Removed,
                [col_name]: item?.[col_name],
              };
            }
          });

          const FINAL = {
            ...Spreadable_Column_Removed,
            ...All_Grouped_Spreaded_columns,
          };
          return FINAL;
        }) ?? [];
    } else {
      tableData = Array.isArray(Data)
        ? Data.map((item) => {
            const columns =
              props?.source_data?.data?.dropdown?.edit_model_column_list ?? [];

            const Final_Columns = [
              ...columns,
              { label: "IS_AI_RECOMMENDED", name: "IS_AI_RECOMMENDED" },
            ];

            return Final_Columns.reduce((acc, col) => {
              acc[col.name] = item?.[col.name] ?? null;
              return acc;
            }, {});
          })
        : [];
    }

    let order_check_data = [];

    if (IS_SPREADABLE_DATA) {
      const FINAL_ORDER_CHECK_DATA = [
        ...(MetaData_Filter || []),
        ...(props?.source_data?.data?.dropdown?.edit_model_column_list.map(
          (item) => item.name,
        ) || []),
      ];
      order_check_data = FINAL_ORDER_CHECK_DATA;
    } else {
      const FINAL_ORDER_CHECK_DATA = [
        ...(MetaData_Filter || []),
        ...(props?.source_data?.data?.dropdown?.edit_model_column_list.map(
          (item) => item.name,
        ) || []),
        "IS_AI_RECOMMENDED",
      ];
      order_check_data = FINAL_ORDER_CHECK_DATA;
    }

    let Sorted_Data = [];
    if (IS_SPREADABLE_DATA) {
      Sorted_Data = tableData;
    } else {
      const FINAL_SORTED_DATA = tableData.map((item) => {
        const { UPDATED_AT, UPDATED_BY, ...rest } = item;
        // filter arrayTwo keeping order of arrayOne
        let result = {};
        order_check_data.forEach((key) => {
          result = {
            ...result,
            [key]: rest[key] || "",
          };
        });
        return result;
      });
      Sorted_Data = FINAL_SORTED_DATA;
    }

    const normalizeExportValue = (value) => {
      if (value === null || value === undefined) return "";
      if (typeof value === "object") return JSON.stringify(value);
      return value;
    };

    const Download_Data = Sorted_Data.map((item) => {
      const normalizedItem = Object.entries(item).reduce(
        (acc, [key, value]) => {
          acc[key] = normalizeExportValue(value);
          return acc;
        },
        {},
      );

      return {
        ...normalizedItem,
        [MetaData_Filter[1]]: props?.source_data?.current_category || "",
        [MetaData_Filter[0]]: COUNTRY?.value || "",
      };
    });

    const sampleData = [...Download_Data];
    const worksheet = XLSX.utils.json_to_sheet(sampleData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Table Data");
    XLSX.writeFile(
      workbook,
      `${Download_Data?.[0]?.[MetaData_Filter?.[1]] || "Table Data"}_${
        props?.source_data?.current_source || ""
      }.xlsx`,
    );
  };

  const handleApplyFilter = (column, values, currentPage, filters) => {
    // STORES AND UPDATE FILTERS
    const newFilters =
      typeof currentPage === "number"
        ? filters
          ? [...filters]
          : [...appliedFilters]
        : [...appliedFilters, { Column: column, Values: values }];
    setAppliedFilters(newFilters);
    props.updateSourceInputs("appliedFilters", newFilters);

    const ALL_ROWS = props.source_data.current_mapped_data || [];

    // CHECK ROWS THAT MATCHES THE FILTERS
    let filtered;
    if (newFilters.length > 0) {
      const FILTERED_ROWS = props.source_data.filtered_Rows;
      const CURRENT_FILTER = [{ Column: column, Values: values }];
      if (FILTERED_ROWS && FILTERED_ROWS.length > 0) {
        if (filters && filters.length > 0) {
          let FILTERED_ROWS = ALL_ROWS;
          filters.forEach((filter) => {
            FILTERED_ROWS = FILTERED_ROWS.filter((row) => {
              const cellValue = row?.rowData?.[filter.Column.name];
              return filter.Values.includes(cellValue);
            });
          });
          filtered = FILTERED_ROWS;
        } else {
          filtered = FILTERED_ROWS.filter((row) =>
            CURRENT_FILTER.some((filter) =>
              filter.Values.includes(row.rowData[filter.Column.name]),
            ),
          );
        }
      } else {
        filtered = ALL_ROWS.filter((row) =>
          CURRENT_FILTER.some((filter) =>
            filter.Values.includes(row.rowData[filter.Column.name]),
          ),
        );
      }
    } else {
      filtered = ALL_ROWS;
    }

    // UPDATES THE FILTERED ROWS
    setFilteredRows(filtered);
    props.updateSourceInputs("filtered_Rows", filtered);

    // UPDATES THE FILTERED ROWS WITH CURRENT PAGINATION
    const Paginated_Rows = handlePaginatedRows(
      typeof currentPage === "number" ? currentPage : 0,
      filtered,
    );
    setPaginatedRows(Paginated_Rows);
    setAllRowsData(filtered);
  };

  const handleRemoveFilter = (filter) => {
    // REMOVES FILTER FROM FILTER LIST
    const SortedFilters = appliedFilters.filter((existingFilter) => {
      const isSame_Column = existingFilter.Column.label === filter.Column.label;

      const valuesA = existingFilter.Values;
      const valuesB = filter.Values;

      const isSame_Values =
        valuesA.length === valuesB.length &&
        valuesA.every((val) => valuesB.includes(val));

      const result = isSame_Column && isSame_Values ? false : true;

      return result;
    });

    setAppliedFilters(SortedFilters);
    props.updateSourceInputs("appliedFilters", SortedFilters);

    const ALL_ROWS = props.source_data.current_mapped_data || [];

    // CHECK ROWS THAT MATCHES THE FILTERS
    let FILTERED_ROWS;
    if (SortedFilters.length > 0) {
      SortedFilters.forEach((filter) => {
        FILTERED_ROWS = ALL_ROWS.filter((row) => {
          const cellValue = row?.rowData?.[filter.Column.name];
          return filter.Values.includes(cellValue);
        });
      });
    } else {
      FILTERED_ROWS = ALL_ROWS;
    }

    // UPDATES THE FILTERED ROWS
    setFilteredRows(FILTERED_ROWS);
    props.updateSourceInputs("filtered_Rows", FILTERED_ROWS);

    // UPDATES THE FILTERED ROWS WITH CURRENT PAGINATION
    const Paginated_Rows = handlePaginatedRows(0, FILTERED_ROWS);
    setPaginatedRows(Paginated_Rows);
    setAllRowsData(FILTERED_ROWS);
  };

  const handleNullCheck = () => {
    const dropdown = props.source_data?.data?.dropdown;
    const currentMappedData = props.source_data?.current_mapped_data;

    return (
      dropdown?.table_header_column_list?.length === 0 &&
      dropdown?.duplicate_validation_attributes?.length === 0 &&
      dropdown?.edit_model_column_list?.length === 0 &&
      Array.isArray(currentMappedData) &&
      currentMappedData.length === 0
    );
  };

  const handleColumnFilter = (columns) => {
    const editModelColumns =
      props?.source_data?.data?.dropdown?.edit_model_column_list || [];
    const Mandatory_Columns =
      props?.source_data?.data?.dropdown?.column_filter_details
        ?.mandatory_column_list || [];

    // SORT EDITABLE COLUMNS
    const Sorted_Columns = [
      ...editModelColumns.filter((item) =>
        Mandatory_Columns?.some((col) => col.name === item.name),
      ),
      ...editModelColumns.filter((item) =>
        columns.some((col) =>
          item.name === "UPC"
            ? col.label === item.name
            : col.name === item.name,
        ),
      ),
    ];

    // SORT TABLE HEADER COLUMNS
    const Sorted_Table_Head_Columns = [
      ...Mandatory_Columns,
      ...columns,
      { label: "Actions", name: "actions" },
    ];

    const Sorted_Columns_Final = [...Sorted_Columns].sort(
      (a, b) =>
        Sorted_Table_Head_Columns.findIndex((col) => col.name === a.name) -
        Sorted_Table_Head_Columns.findIndex((col) => col.name === b.name),
    );

    // SET STATES
    setTableHeadColumns(Sorted_Table_Head_Columns);
    setSelectedColumns(Sorted_Columns_Final);
    props.updateSourceInputs("current_columns", columns);
  };

  const handleColumnChange = () => {
    const editModelColumns =
      props?.source_data?.data?.dropdown?.edit_model_column_list || [];
    const currentColumns = props?.source_data?.current_columns || [];
    const Mandatory_Columns =
      props?.source_data?.data?.dropdown?.column_filter_details
        ?.mandatory_column_list || [];

    if (!Array.isArray(editModelColumns) || !Array.isArray(currentColumns)) {
      return;
    }

    if (editModelColumns.length === 0 || currentColumns.length === 0) {
      return;
    }

    // SORT EDITABLE COLUMNS
    const Sorted_Columns = [
      ...editModelColumns.filter((item) =>
        Mandatory_Columns?.some((col) => col.name === item.name),
      ),
      ...editModelColumns.filter((item) =>
        currentColumns.some((col) =>
          item.name === "UPC"
            ? col.label === item.name
            : col.name === item.name,
        ),
      ),
    ];

    // SORT TABLE HEADER COLUMNS
    const Sorted_Table_Head_Columns = [
      ...Mandatory_Columns,
      ...currentColumns,
      { label: "Actions", name: "actions" },
    ];

    const Sorted_Columns_Final = [...Sorted_Columns].sort(
      (a, b) =>
        Sorted_Table_Head_Columns.findIndex((col) => col.name === a.name) -
        Sorted_Table_Head_Columns.findIndex((col) => col.name === b.name),
    );

    // SET STATES
    setTableHeadColumns(Sorted_Table_Head_Columns);
    setSelectedColumns(Sorted_Columns_Final);
  };

  useEffect(() => {
    handleColumnChange();
  }, [props.source_data.current_columns]);

  useEffect(() => {
    setAllRowsData(props.defaultData || []);
    const Paginated_Rows = handlePaginatedRows(page, props.defaultData);

    setPaginatedRows(Paginated_Rows);
  }, [props.defaultData]);

  // Apply Filters
  useEffect(() => {
    // Reapply all filters
    if (
      props.source_data.appliedFilters &&
      props.source_data.appliedFilters.length > 0
    ) {
      handleApplyFilter(
        appliedFilters.Column,
        appliedFilters.Values,
        page,
        props.source_data.appliedFilters,
      );
    }

    if (
      props.source_data.searchValue &&
      props.source_data.searchValue.length > 0
    ) {
      handleSearchValue(props.source_data.searchValue);
    }
  }, [props.source_data.current_mapped_data]);

  // Apply Search Filter
  useEffect(() => {
    // Apply search
    const searchValue = props.source_data.searchValue;
    const hasSearchValue =
      typeof searchValue === "string" && searchValue.length > 0;
    const hasFilteredRows =
      Array.isArray(props.source_data.filtered_Rows) &&
      props.source_data.filtered_Rows.length > 0;

    if (hasSearchValue && hasFilteredRows) {
      const Filtered_Rows = props.source_data.filtered_Rows;
      const filtered = Filtered_Rows.filter((item) =>
        (item?.rowData?.[PRIMARY_COLUMN] || "")
          .toLowerCase()
          .includes(searchValue.toLowerCase()),
      );

      const Paginated_Rows = handlePaginatedRows(page, filtered);
      setPaginatedRows(Paginated_Rows);
      setAllRowsData(filtered);
    }
  }, [props.source_data.filtered_Rows]);

  useEffect(() => {
    if (
      props.source_data.appliedFilters.length === 0 &&
      appliedFilters.length > 0
    ) {
      setAppliedFilters([]);
    }
  }, [props.source_data.appliedFilters]);

  useEffect(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    const AllRowsChecked =
      props?.source_data?.current_mapped_data
        ?.slice(startIndex, endIndex)
        ?.every((item, i) => {
          return item.isCheckedRow === true;
        }) ?? false;

    setIsAllRowsInPageChecked(AllRowsChecked);
  }, [props.source_data.checked_rows_count]);

  if (handleNullCheck()) {
    return <Loader />;
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* SEARCH FILTER */}
        {props?.source_data?.data?.dropdown?.search_filter_details
          ?.is_search_filter && (
          <SearchBar
            handleSearchValue={handleSearchValue}
            placeholder={`Search with ${
              (
                props?.source_data?.data?.dropdown?.search_filter_details
                  ?.search_filter_attributes || []
              )
                .map((attr) => attr?.label)
                .filter(Boolean)
                .join(", ") || "..."
            }`}
            value={props?.source_data?.searchValue ?? ""}
          />
        )}

        {/* RECOMENDATION STATUS LABEL */}
        {props.source_data.get_recommendation_for_all_rows && (
          <div
            style={{
              backgroundColor: RECOMMENDATION_STATUS_COLOR?.bg_color || "",
              padding: "2px 10px",
              paddingRight: "10px",
              paddingLeft: "5px",
              borderRadius: "30px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            {props.source_data.get_recommendation_status === "Failed" && (
              <span
                style={{
                  color: RECOMMENDATION_STATUS_COLOR?.icon || "",
                  fontSize: "0px",
                }}
              >
                <i className="material-icons-outlined">error</i>
              </span>
            )}
            {props.source_data.get_recommendation_status === "In Progress" && (
              <span
                style={{
                  color: RECOMMENDATION_STATUS_COLOR?.icon || "",
                  fontSize: "0px",
                }}
              >
                <i className="material-icons-outlined">hourglass_top</i>
              </span>
            )}
            {props.source_data.get_recommendation_status === "Success" && (
              <span
                style={{
                  color: RECOMMENDATION_STATUS_COLOR?.icon || "",
                  fontSize: "0px",
                }}
              >
                <i className="material-icons-outlined">task_alt</i>
              </span>
            )}
            <span
              style={{
                color: RECOMMENDATION_STATUS_COLOR?.icon || "",
                fontWeight: "600",
                fontSize: "12px",
                marginTop: "3px",
              }}
            >
              AI Recommendations:{" "}
              {props.source_data.get_recommendation_status || ""}
            </span>
          </div>
        )}

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {/* MULTI FILTER */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {/* Filter Pill */}
            <div className="scroll-bar">
              {appliedFilters.map((filter) => {
                return (
                  <div className="pill">
                    <span
                      style={{
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {filter.Column.label}
                    </span>
                    <span
                      style={{
                        margin: "0 6px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      is one of
                    </span>
                    <span
                      style={{
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100px",
                      }}
                    >
                      {filter.Values.map((v) =>
                        v === null
                          ? "Null"
                          : v === undefined
                            ? "Undefined"
                            : String(v),
                      ).join(", ")}
                    </span>
                    <button
                      onClick={() => handleRemoveFilter(filter)}
                      style={{
                        marginLeft: "8px",
                        color: "#666",
                        fontSize: "18px",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = "#e00")}
                      onMouseLeave={(e) => (e.target.style.color = "#666")}
                    >
                      &times;
                    </button>
                  </div>
                );
              })}
            </div>

            {/* Filter Button */}
            <div>
              {props?.source_data?.data?.dropdown &&
                props?.source_data?.data?.dropdown?.filter_details
                  ?.is_filterable && (
                  <button
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    className="filter-button"
                  >
                    <span
                      className="material-symbols-outlined"
                      style={{
                        fontVariationSettings: "'wght' 200",
                        fontSize: "20px",
                      }}
                    >
                      {props?.source_data?.data?.dropdown?.filter_details
                        ?.button_icon || "filter_alt"}
                    </span>
                    <span>
                      {props?.source_data?.data?.dropdown?.filter_details
                        ?.button_text || "Filter"}
                    </span>
                  </button>
                )}
            </div>

            {/* Filter POPOVER */}
            {props?.source_data?.data?.dropdown?.filter_details && (
              <MultiFilter
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                columns={
                  props.source_data.data.dropdown.filter_details.filter_details
                }
                values={
                  filteredRows && filteredRows.length > 0
                    ? filteredRows
                    : props.source_data.current_mapped_data || []
                }
                onApplyFilter={handleApplyFilter}
              />
            )}
          </div>

          {/* COLUMN FILTER */}
          {props?.source_data?.data?.dropdown?.column_filter_details &&
            props?.source_data?.data?.dropdown?.column_filter_details
              ?.is_column_filterable && (
              <div>
                {/* BUTTON */}
                <button
                  onClick={handleOpenColumnFilter}
                  className="filter-button"
                >
                  <span
                    className="material-symbols-outlined"
                    style={{
                      fontVariationSettings: "'wght' 200",
                      fontSize: "20px",
                    }}
                  >
                    {props?.source_data?.data?.dropdown?.column_filter_details
                      ?.button_icon || "table_edit"}
                  </span>
                  <span>
                    {props?.source_data?.data?.dropdown?.column_filter_details
                      ?.button_text || "Columns"}
                  </span>
                </button>

                {/* POPOVER */}
                <ColumnFilter
                  anchorE2={anchorE2}
                  setAnchorE2={setAnchorE2}
                  totalColumns={
                    props?.source_data?.data?.dropdown?.column_filter_details
                      ?.filterable_columns || []
                  }
                  tableHeaderColumns={tableHeadColumns.filter((col) => {
                    const Result =
                      props?.source_data?.data?.dropdown?.column_filter_details?.mandatory_column_list.some(
                        (mandotorycol) => mandotorycol.name === col.name,
                      );
                    return !Result && col.name !== "actions";
                  })}
                  standardHeaderColumns={props?.source_data?.data?.dropdown?.table_header_column_list.filter(
                    (item) => {
                      const Result =
                        props?.source_data?.data?.dropdown?.column_filter_details?.mandatory_column_list.some(
                          (col) => col.name === item.name,
                        );
                      return !Result;
                    },
                  )}
                  onApplyFilter={handleColumnFilter}
                  updateAlert={props.updateAlert}
                  sourceData={props?.source_data}
                  useCase={"AttributeEnrichment"}
                />
              </div>
            )}

          {/* DOWNLOAD BUTTON */}
          {props?.source_data?.data?.dropdown?.downloable_details &&
            props?.source_data?.data?.dropdown?.downloable_details
              ?.is_downloadble && (
              <button onClick={handleDownload} className="filter-button">
                <span
                  className="material-symbols-outlined"
                  style={{
                    fontVariationSettings: "'wght' 200",
                    fontSize: "20px",
                  }}
                >
                  {props?.source_data?.data?.dropdown?.downloable_details
                    ?.button_icon || ""}
                </span>
                <span>
                  {props?.source_data?.data?.dropdown?.downloable_details
                    ?.button_text || "Download"}
                </span>
              </button>
            )}

          {/* PowerBI Button */}
          {props?.source_data?.data?.dropdown?.POWER_BI_DETAILS &&
            props?.source_data?.data?.dropdown?.POWER_BI_DETAILS
              ?.IS_POWER_BI && (
              <a
                href={
                  props?.source_data?.data?.dropdown?.POWER_BI_DETAILS
                    ?.POWER_BI_URL || "#"
                }
                target="_blank"
                rel="noopener noreferrer"
                className="powerbi-button"
              >
                <span
                  className="material-symbols-outlined"
                  style={{
                    fontVariationSettings: "'wght' 200",
                    fontSize: "20px",
                  }}
                >
                  {props?.source_data?.data?.dropdown?.POWER_BI_DETAILS
                    ?.button_icon || ""}
                </span>
                <span>
                  {props?.source_data?.data?.dropdown?.POWER_BI_DETAILS
                    ?.button_text || "PowerBI Dashboard"}
                </span>
              </a>
            )}
        </div>
      </div>

      <TableContainer className={Tablestyles.budget_tb2}>
        <Table
          stickyHeader
          className={classNames(classes.table, `table_${tableName}`)}
        >
          <TableHead className="table-heading">
            <TableRow
              className={classNames(
                classes.tableHeadRow,
                `tableHeadRow_${tableName}`,
              )}
            >
              {tableHeadColumns.map(({ label, name }, i) => (
                <StyledTableCell key={i}>
                  {i === 0 ? (
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginLeft: "3px",
                      }}
                    >
                      {props?.source_data?.data?.dropdown
                        ?.recommendation_details?.is_recommendation && (
                        <input
                          type="checkbox"
                          style={{ height: "14px", width: "14px" }}
                          onChange={handleCheckboxAll}
                          checked={isAllRowsInPageChecked}
                        />
                      )}
                      <span>{label}</span>
                    </div>
                  ) : (
                    label
                  )}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {paginatedRows.map((rowData, i) =>
              rowData.isEditing ? (
                <EditableRow
                  key={i}
                  keys={i}
                  tableName={tableName}
                  isEditing={rowData.isEditing}
                  customStyles={customStyles}
                  editingIndex={editingIndex}
                  brand_data={props.brand_data}
                  updateSourceInputs={props.updateSourceInputs}
                  sourceData={props.source_data}
                  selectClasses={classes}
                  inputClasses={classes}
                  classes={classes}
                  allRowsData={allRowsData}
                  editData={rowData.rowData}
                  handleSave={handleSave}
                  handleCancel={handleCancel}
                  fieldsArr={selectedColumns}
                  user={props.user}
                  updateAlert={props.updateAlert}
                  tableHeadColumns={tableHeadColumns}
                />
              ) : (
                <Row
                  key={i}
                  keys={i}
                  tableName={tableName}
                  classes={classes}
                  handleModalOpen={handleModalopen}
                  handleRecommendationModalopen={handleRecommendationModalopen}
                  headingRow={tableHeadColumns || []}
                  isAdding={isAdding}
                  isEditing={isEditing || props.source_data.any_row_isEditing}
                  handleEditRow={handleEditRow}
                  handleDeleteRow={() => handleDeleteRow(i)}
                  allRowsData={allRowsData}
                  rowData={rowData}
                  isAllRowsInPageChecked={isAllRowsInPageChecked}
                  rowChecked={rowData.isCheckedRow}
                  updateSourceHandler={props.updateSourceHandler}
                  checkedRowCount={checkedRowCount}
                  startIndex={page * rowsPerPage}
                  endIndex={page * rowsPerPage + rowsPerPage}
                  sourceData={props.source_data}
                />
              ),
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {allRowsData.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={allRowsData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}

      {!allRowsData.length && (
        <div style={{ textAlign: "center" }}>No Data Found.</div>
      )}

      {openModel &&
        (isRecommand ? (
          <RecommandationModal
            actualData={[modalData]}
            closeModel={handleRecommendationCloseModal}
            openModel={openModel}
            selectClasses={classes}
            inputClasses={classes}
            updateSourceInputs={props.updateSourceInputs}
            sourceData={props.source_data}
            setGlobalEdit={props.setGlobalEdit}
            user={props.user}
            updateAlert={props.updateAlert}
          />
        ) : (
          <CustomModal
            tableName={tableName}
            heading="Recommendations"
            modelData={modalData}
            closeModel={handleCloseModel}
            openModel={openModel}
            sourceDropdownData={props.sourceDropdownData}
            selectClasses={classes}
            inputClasses={classes}
            updateSourceInputs={props.updateSourceInputs}
            sourceData={props.source_data}
            setGlobalEdit={props.setGlobalEdit}
            pageStart={page * rowsPerPage}
            pageEnd={page * rowsPerPage + rowsPerPage}
            user={props.user}
            updateAlert={props.updateAlert}
          />
        ))}
    </>
  );
};

EditableTableAttribute.propTypes = {
  brand_data: PropTypes.object,
  updateAlert: PropTypes.func,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  source_data: state.source,
  user: state.user,
});

const mapDispatchToProps = {
  updateSourceInputs,
  updateAlert,
};

// export default EditableTable;
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EditableTableAttribute),
);
